import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useState } from 'react'
import SuperAccordion from 'Components/SuperAccordion/SuperAccordion'
import { FiChevronDown, FiChevronUp } from 'react-icons/fi'
import { ELIGIBILITY_TYPES, TODAY_DATE } from 'Common/Constants'
import CustomRadio from 'Common/CustomRadio'
import { ErrorHandlingMessage } from 'Utils/ErrorHandlingMessage'
import api from 'http'
import Validator, { ValidationTypes as V_Type, } from 'react-form-supervalidator';
import { toast } from 'react-toastify'
import FullPageLoader from 'Components/FullPageLoader/FullPageLoader'
import CustomButtonNew from 'Common/CustomButtonNew/CustomButtonNew'
import AsyncSelect from 'Common/AsyncSelect/AsyncSelect'
import { GetInsurancePlan } from 'Utils/Utils'
import CustomSelect from 'Common/CustomSelect/CustomSelect'
import CustomInput from 'Common/CustomInput/CustomInput'
import { ELIGIBILITY_RUN_SUCCESSFULLY } from 'Common/ToastConstants'
import CostShare from './EligibilityLogDetail/CostShare'
import PatientPaymentsOverview from 'MainTabs/Patients/AllPatients/PatientPayments/PaymentSettings/PatientPaymentsOverview'
import AddNewPatientPaymentPopup from 'Popups/AddNewPatientPaymentPopup/AddNewPatientPaymentPopup'
import Show from 'Components/Show/Show'
import PatientSuperSearch from 'NewComponents/UtilityComponents/PatientSuperSearch/PatientSuperSearch'
import CptSuperSearch from 'NewComponents/UtilityComponents/CptSuperSearch/CptSuperSearch'


const RunEligibilityForm = forwardRef(({
    patientId = null,
    getEligibilityModel,
    allPlans = [],
    singlePlan = null,
    cptCode = "",
    providerId = "",
    dateOfService = "",
    serviceType = "",
    status = true,
    patientName = "",
    payerId: preSelectedPayerId = null,
    subscriberId: preFilledSubscriberId = "",
    patientDob: preFilledPatientDob = "",
    patientPlanId: preFilledPatientPlanId = null,
    subscriberFirstName: preFilledSubscriberFirstName = "",
    subscriberLastName: preFilledSubscriberLastName = "",
    patientRelation: preFilledPatientRelation = "",
    insurancePayerTypeId: preFilledInsurancePayerTypeId = null,
    hideRunButton = false,
    hideCostShareAndPayment = false,
    runEligibilityModel: controlledRunEligibilityModel,
    setRunEligibilityModel: setControlledRunEligibilityModel,
    costShareData: controlledCostShareData,
    setCostShareData: setControlledCostShareData,
    allPayers: controlledAllPayers,
    fetchCostShareData: controlledFetchCostShareData,
}, ref) => {
    const isControlled = controlledRunEligibilityModel != null && setControlledRunEligibilityModel != null
    const [internalRunEligibilityModel, setInternalRunEligibilityModel] = useState({
        providerId: providerId || "",
        type: cptCode ? "cpt" : "serviceType",
        serviceTypeCode: serviceType || "",
        accountKey: "",
        subscriberLastName: "",
        subscriberFirstName: "",
        payerId: "",
        patientRelation: "",
        dateOfService: (dateOfService && dateOfService.split) ? dateOfService.split('T')[0] : TODAY_DATE,
        subscriberId: "",
        cptCode: cptCode || "",
        patientDob: "",
        patientId: "",
        patientPlanId: "",
        createdBy: "",
        payerName: "",
        patientname: "",
        insurancePayerTypeId: null
    })
    const runEligibilityModel = isControlled ? controlledRunEligibilityModel : internalRunEligibilityModel
    const setRunEligibilityModel = isControlled ? setControlledRunEligibilityModel : setInternalRunEligibilityModel

    const [validationModel, setValidationModel] = useState({
        patientIdError: "",
        payerError: "",
        providerIdError: "",
        serviceTypeCodeError: ""
    })
    const noop = useCallback(() => {}, [])
    const [internalAllPayers, setInternalAllPayers] = useState([])
    const allPayers = isControlled && controlledAllPayers != null ? controlledAllPayers : internalAllPayers
    const setAllPayers = isControlled ? noop : setInternalAllPayers
    const [loading, setLoading] = useState(false)
    const [addPaymentPopup, setAddPaymentPopup] = useState(false)
    const [sectionsOpen, setSectionsOpen] = useState({
        costShare: true,
        patientPayment: true,
    })
    const onToggleSection = (section) => {
        setSectionsOpen((prev) => ({ ...prev, [section]: !prev[section] }))
    }
    const [internalCostShareData, setInternalCostShareData] = useState({
        copay: "",
        deductible: "",
        coInsurance: "",
        outOfPocketMax: "",
        patientCredit: 0,
        lastPaymentDate: "",
        paidAmount: 0,
        patientBalance: 0,
    })
    const costShareData = isControlled && controlledCostShareData != null ? controlledCostShareData : internalCostShareData
    const setCostShareData = isControlled && setControlledCostShareData ? setControlledCostShareData : setInternalCostShareData
    const internalFetchCostShareData = useCallback(async () => {
        try {
            if (runEligibilityModel.payerId) {
                setLoading(true)
                const response = await api.get(
                    `${process.env.REACT_APP_TC_PMS}/api/Patient/FindPatientInsuranceCostShare?PatientId=${patientId}`
                )
                setCostShareData(response.data?.dataModel ?? {})
                const data = response.data?.dataModel
                if (data && Array.isArray(data)) {
                    const model = allPayers.find(item => item.payerId === runEligibilityModel.payerId)
                    const matchedData = model ? data.find(item => item.coverage === model.coverage) : null
                    if (matchedData) setCostShareData(matchedData)
                }
            }
        } catch (error) {
            ErrorHandlingMessage(error)
        } finally {
            setLoading(false)
        }
    }, [patientId, allPayers, runEligibilityModel.payerId, setCostShareData])
    const fetchCostShareData = controlledFetchCostShareData ?? internalFetchCostShareData


    const handleSelectedData = async (selectedObj, searchName) => {
        if (selectedObj) {
            if (searchName === "CPT") {
                setRunEligibilityModel((prev) => ({
                    ...prev,
                    cptCode: selectedObj.cptCode,
                }));
            } else if (searchName === "Patient") {
                try {
                    const plansResp = await api.get(`${process.env.REACT_APP_TC_PMS}/api/DropDown/FindPatientPlanByPatientId?PatientId=${selectedObj.id}`);
                    setAllPayers(plansResp.data.dataModel)
                } catch (error) {
                    ErrorHandlingMessage(error)
                }
                setRunEligibilityModel((prev) => ({
                    ...prev,
                    patientId: selectedObj.id,
                    patientname: selectedObj.name
                }));
            }
        } else {
            if (searchName === "CPT") {
                setRunEligibilityModel((prev) => ({
                    ...prev,
                    cptCode: "",
                }));
            } else if (searchName === "Patient") {
                setRunEligibilityModel((prev) => ({
                    ...prev,
                    patientId: "",
                    patientname: "",
                }));
                setAllPayers([])
            }
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "type") {
            setRunEligibilityModel((prev) => ({
                ...prev,
                cptCode: "",
                serviceTypeCode: "",
                [name]: value
            }))
            setValidationModel((prev) => ({
                ...prev,
                serviceTypeCodeError: ""
            }))
        }
        else if (name === "payerId") {
            // Handle "Please Select" (empty value)
            if (!value || value === "") {
                setRunEligibilityModel((prev) => ({
                    ...prev,
                    subscriberId: "",
                    subscriberFirstName: "",
                    subscriberLastName: "",
                    patientPlanId: "",
                    patientDob: "",
                    patientRelation: "",
                    insurancePayerTypeId: null,
                    payerId: "",
                    payerName: "",
                    [name]: value
                }));
            } else {
                const selectedPlan = allPayers.find(item => item.payerId.toString() === value);

                if (selectedPlan) {
                    setRunEligibilityModel((prev) => ({
                        ...prev,
                        subscriberId: selectedPlan.subscriberId,
                        subscriberFirstName: selectedPlan.patientFirstName,
                        subscriberLastName: selectedPlan.patientLastName,
                        patientPlanId: selectedPlan.patientPlanID,
                        patientDob: selectedPlan.patientDOB,
                        patientRelation: selectedPlan.relationShip,
                        insurancePayerTypeId: selectedPlan.insurancePayerTypeId,
                        payerId: selectedPlan.payerId,
                        payerName: selectedPlan.insurancePayerName,
                        [name]: value
                    }));
                }
            }
        }
        else {
            setRunEligibilityModel((prev) => ({
                ...prev,
                [name]: value
            }))
        }

    }

    const setValidation = () => {
        let validationObj = {
            ...validationModel,
            patientIdError: Validator(runEligibilityModel.patientId, [V_Type.required], ['Patient is required'],),
            payerError: Validator(runEligibilityModel.payerId, [V_Type.required], ['Plan  is required'],),
            providerIdError: Validator(runEligibilityModel.providerId, [V_Type.required], ['Provider  is required'],),
            ...(runEligibilityModel.type === "serviceType" && { serviceTypeCodeError: Validator(runEligibilityModel.serviceTypeCode, [V_Type.required], ['Service Type  is required'],) })
        }
        setValidationModel(validationObj)
        return Validator(validationObj, V_Type.NullCheck);
    }
    const onRunEligibility = async () => {
        let myValidation = setValidation();

        if (myValidation) {
        } else {
            try {
                setLoading(true)
                const response = await api.post(`${process.env.REACT_APP_TC_PMS}/api/ClearingHouseApi/RunPatientEligibilityRequest`, runEligibilityModel)
                toast.success(ELIGIBILITY_RUN_SUCCESSFULLY);
                getEligibilityModel(response, runEligibilityModel)
            } catch (error) {
                if (error.response.data.dataModel) {
                    getEligibilityModel(error.response, runEligibilityModel)
                }

                ErrorHandlingMessage(error)
            }
            finally {
                setLoading(false)
            }
        }
    }

    useImperativeHandle(ref, () => ({
        runEligibility: onRunEligibility,
    }))

    useEffect(() => {

        if ((preFilledSubscriberId && preFilledSubscriberId !== "") || (preSelectedPayerId && preSelectedPayerId !== null)) {
            setRunEligibilityModel((prev) => ({
                ...prev,
                patientId: patientId || prev.patientId,
                patientname: patientName || prev.patientname,
                subscriberId: preFilledSubscriberId || prev.subscriberId,
                subscriberFirstName: preFilledSubscriberFirstName || prev.subscriberFirstName,
                subscriberLastName: preFilledSubscriberLastName || prev.subscriberLastName,
                patientPlanId: preFilledPatientPlanId || prev.patientPlanId,
                patientDob: preFilledPatientDob || prev.patientDob,
                patientRelation: preFilledPatientRelation || prev.patientRelation,
                insurancePayerTypeId: preFilledInsurancePayerTypeId || prev.insurancePayerTypeId,
                payerId: preSelectedPayerId || prev.payerId,
            }));

            if (allPlans.length > 0) {
                setAllPayers(allPlans);
            }
        } else if (allPlans.length > 0) {

            const insInfo = singlePlan || GetInsurancePlan(allPlans)

            setRunEligibilityModel((prev) => ({
                ...prev,
                patientId: patientId || insInfo.patientId,
                patientname: patientName || insInfo.patientName || prev.patientname,
                subscriberId: insInfo.subscriberId,
                subscriberFirstName: insInfo.patientFirstName,
                subscriberLastName: insInfo.patientLastName,
                patientPlanId: insInfo.patientPlanID,
                patientDob: insInfo.patientDob,
                cptCode: cptCode || insInfo.cptCode,
                patientRelation: insInfo.relationShip,
                dateOfService: dateOfService.split('T')[0] || insInfo.eligibilityDate,
                insurancePayerTypeId: insInfo.insurancePayerTypeId,
                payerId: preSelectedPayerId || insInfo.payerId || prev.payerId,
                payerName: insInfo.insurancePayerName,
                providerId: providerId || insInfo.providerId,
                serviceTypeCode: serviceType || insInfo.serviceTypeCode,
                type: cptCode ? "cpt" : "serviceType",
            }));
            setAllPayers(allPlans);
        } else if (patientId && patientName) {

            setRunEligibilityModel((prev) => ({
                ...prev,
                patientId: patientId,
                patientname: patientName,
            }));
        }
    }, [allPlans, singlePlan, patientId, patientName, preSelectedPayerId, preFilledSubscriberId, providerId, serviceType, cptCode, dateOfService, preFilledPatientDob, preFilledPatientPlanId, preFilledSubscriberFirstName, preFilledSubscriberLastName, preFilledPatientRelation, preFilledInsurancePayerTypeId, setRunEligibilityModel, setAllPayers])
    useEffect(() => {
        if (patientId && status && !isControlled) {
            fetchCostShareData()
        }
    }, [patientId, fetchCostShareData, status, isControlled])
    const effectivePatientId = patientId || runEligibilityModel.patientId

    return (
        <>
            {loading && <FullPageLoader allowFullScreen />}
            <Show when={addPaymentPopup}>
                <AddNewPatientPaymentPopup
                    currentTab="patient payments"
                    patientId={effectivePatientId}
                    onClose={() => setAddPaymentPopup(false)}
                    onPaymentConfirmed={fetchCostShareData}
                    handleSubmit={fetchCostShareData}
                />
            </Show>
            {!hideRunButton && (
                <div className='flex justify-end mb-2'>
                    <CustomButtonNew onClick={onRunEligibility} label="Run Eligibility" />
                </div>
            )}
            <div className='grid grid-cols-12 gap-4'>

                {!patientId ? (
                    <div className='col-span-12'>
                        <PatientSuperSearch
                            disabled={patientId}
                            label="Patient Name"
                            labelRequired
                            searchValue={runEligibilityModel.patientname}
                            onChange={(value) => setRunEligibilityModel((prev) => ({ ...prev, patientname: value }))}
                            handleSelectedData={(value) => handleSelectedData(value, "Patient")}
                            width='100%'
                        />
                        {validationModel.patientIdError}
                    </div>
                ) : (
                    <div className='col-span-12'>
                        <CustomInput
                            label={"Patient Name"}
                            value={runEligibilityModel.patientname || patientName || ""}
                            disabled={true}
                            readOnly
                        />
                    </div>
                )}

                <div className='grid grid-cols-12 col-span-12 gap-4  pb-2'>
                    <div className='col-span-3'>
                        <CustomSelect
                            value={runEligibilityModel.payerId}
                            onChange={handleChange}
                            name="payerId"
                            required
                            label={"Payer"}
                        >
                            {(!runEligibilityModel.payerId || !status) && <option value={""}>Please Select</option>}
                            {allPayers?.map((plan, index) => (<option key={index} value={plan.payerId}>    ({plan.coverage}) - {plan.insuranceName || plan.insurancePayerName} - {plan.subscriberId}  </option>))}
                        </CustomSelect>
                        {validationModel.payerError}
                    </div>

                    <div className='col-span-2'>
                        <AsyncSelect
                            name="providerId"
                            required
                            value={runEligibilityModel.providerId}
                            onChange={handleChange}
                            label="Rendering Provider"
                            apiLink={`${process.env.REACT_APP_TC_PMS}/api/DropDown/FindBillingProviders`}
                        />
                        {validationModel.providerIdError}
                    </div>

                    <div className="col-span-12 md:col-span-2">
                        <CustomInput type={"date"} value={runEligibilityModel.dateOfService} name="dateOfService" label={"Service Date"} onChange={handleChange} />
                    </div>
                    {runEligibilityModel.type === "serviceType" ?
                        (
                            <div className="col-span-12 md:col-span-2">
                                <CustomSelect onChange={handleChange} value={runEligibilityModel.serviceTypeCode} name="serviceTypeCode" required label="Type" >
                                    <option value="">Please Select</option>
                                    {ELIGIBILITY_TYPES.map(type => <option value={type.value}>{type.label}- ({type.value})</option>)}
                                </CustomSelect>
                                {validationModel.serviceTypeCodeError}
                            </div>
                        ) : (
                            <div className="col-span-12 md:col-span-2">
                                <CptSuperSearch
                                    searchValue={runEligibilityModel.cptCode}
                                    label="Procedure"
                                    onChange={(value) => setRunEligibilityModel((prev) => ({ ...prev, cptCode: value }))}
                                    handleSelectedData={(value) => handleSelectedData(value, "CPT")}
                                    identifier='EligibilityCptSuperSearch'
                                />
                            </div>
                        )}
                    <div className="col-span-12 md:col-span-3 flex items-start pt-10 pb-2">
                        <CustomRadio
                            name="type"
                            checked={runEligibilityModel.type}
                            options={[
                                { value: 'serviceType', label: 'Service Type' },
                                { value: 'cpt', label: 'CPT Code' }]}
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </div>
            {status && !hideCostShareAndPayment && (
                <>
                    {/* Cost Share - collapsible (inside form when not hideCostShareAndPayment) */}
                    <div className="border rounded-lg border-slate-200 overflow-hidden mt-4">
                        <div
                            className="flex items-center justify-between cursor-pointer py-3 px-4 bg-slate-50 border-b border-slate-200"
                            onClick={() => onToggleSection('costShare')}
                        >
                            <h2 className="text-lg font-semibold text-gray-900">Cost Share</h2>
                            {sectionsOpen.costShare ? <FiChevronUp className="text-gray-500 shrink-0 cursor-pointer" /> : <FiChevronDown className="text-gray-500 shrink-0 cursor-pointer" />}
                        </div>
                        <SuperAccordion show={sectionsOpen.costShare}>
                            <div className="p-4">
                                <CostShare
                                    className='my-0'
                                    coverage={runEligibilityModel.coverage}
                                    costShareData={costShareData}
                                    allPayers={allPayers}
                                    runEligibilityModel={runEligibilityModel}
                                    loading={false}
                                />
                            </div>
                        </SuperAccordion>
                    </div>

                    {/* Patient Payment - collapsible (inside form when not hideCostShareAndPayment) */}
                    <div className="border rounded-lg border-slate-200 overflow-hidden mt-4">
                        <div
                            className="flex items-center justify-between cursor-pointer py-3 px-4 bg-slate-50 border-b border-slate-200"
                            onClick={() => onToggleSection('patientPayment')}
                        >
                            <h2 className="text-lg font-semibold text-gray-900">Patient Payment</h2>
                            <div className="flex items-center gap-2">
                                <div onClick={(e) => e.stopPropagation()}>
                                    <CustomButtonNew
                                        onClick={() => setAddPaymentPopup(true)}
                                        label="Add Payment"
                                        disabled={!effectivePatientId}
                                    />
                                </div>
                                {sectionsOpen.patientPayment ? <FiChevronUp className="text-gray-500 shrink-0 cursor-pointer" /> : <FiChevronDown className="text-gray-500 shrink-0 cursor-pointer" />}
                            </div>
                        </div>
                        <SuperAccordion show={sectionsOpen.patientPayment}>
                            <div className="p-4">
                                <PatientPaymentsOverview patientAccountInfo={{
                                    patientBalance: costShareData.patientBalance || 0,
                                    patientCredit: costShareData.patientCredit || 0,
                                    lastPaymentDate: costShareData.lastPaymentDate || "",
                                    extraClass: "px-4 py-2",
                                    paidAmount: costShareData.paidAmount || 0,
                                }} />
                            </div>
                        </SuperAccordion>
                    </div>
                </>
            )}
        </>

    )
})

RunEligibilityForm.displayName = 'RunEligibilityForm'

export default RunEligibilityForm